// CONSTANTS
import { ROUTE_PARTNER_SHOWS_AND_MOVIES_SHOW } from '@/constants/routes';

// UTILITY
import { getGenresNames } from '@/utility/content';
import getLink from '@/utility/routes';

export default data => {
  const url = data?.slug
    ? getLink(ROUTE_PARTNER_SHOWS_AND_MOVIES_SHOW, { show_id: data?.slug })
    : '';

  const seasons = data.seasons?.map(season => {
    return {
      '@type': 'TVSeason',
      name: season?.name,
      datePublished: season?.air_date,
      numberOfEpisodes: season?.total_episodes,
    };
  });

  return {
    '@type': 'TVSeries',
    name: data?.content_title,
    description: data?.overview,
    containsSeason: seasons || [],
    numberOfSeasons: seasons?.length || 0,
    startDate: data?.year_range?.start || '',
    endDate: data?.year_range?.end || '',
    datePublished: data?.year_range?.start || '',
    genre: data?.genres?.length ? getGenresNames(data.genres) : '',
    thumbnailUrl: data?.thumbnail,
    image: data?.thumbnail,
    url,
  };
};
